import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'Accueil',
    link: '/'
  },
  {
    id: 2,
    label: 'Entreprises',
    link: '/catalog/grid',
    type: 'entreprises'
  },
  {
    id: 3,
    label: 'Pharmacies',
    link: '/catalog/grid',
    type: 'pharmacies'
  },
  {
    id: 3,
    label: 'Institutions',
    link: '/catalog/grid',
    type: 'institutions'
  },
  {
    id: 4,
    label: 'Offres publics/privés',
    link: '/catalog/offres',
  },
  {
    id: 5,
    label: 'Textes Officiels',
    link: '/catalog/gov',
  },
];
